<template>
  <v-container fluid>
     <v-btn color="accent" class="orderGapClass" @click="$router.push({ name: 'orderGap' })">
      Order Gap
    </v-btn>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="Generate Student Uniform Indent"
    >
      <a @click="$router.back()">
        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          elevation="1"
          absolute
          right
          top
        >
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn
          v-else
          fixed
          right
          fab
          small
          color="grey lighten-2"
          elevation="1"
          class="mr-n2 mt-10"
          style="opacity: 0.6"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-text
        class="pt-0 pr-1"
        :class="{
          'd-block py-3': $vuetify.breakpoint.xs,
          'd-flex align-center': $vuetify.breakpoint.smAndUp
        }"
      >
        <!--Filter Section Start -->
        <v-row>
          <v-col cols="12" md="4">
            <label class="font-weight-medium body-2"> Class & Section </label>
            <multiselect
              class="overflowmultiselect2"
              label="value"
              track-by="id"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :preselect-first="false"
              :multiple="true"
              :options="classSectionArray"
              v-model="selectedClassSectionArray"
              @input="getStudentDetails(true)"
            >
            </multiselect>
          </v-col>
          <v-col cols="12" md="3">
            <label class="font-weight-medium body-2"> Order Status </label>
            <v-autocomplete
              class="my-0 py-1"
              placeholder="--All Orders--"
              name="classSelect"
              v-model="selectedOrderStatus"
              v-on:change="getStudentDetails(true)"
              item-value="id"
              :items="orderStatusOptions"
              key="id"
              item-text="name"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <span class="font-weight-medium body-2">Action</span>
            <div class="inside">
              <v-btn elevation="1" color="success" @click="getStudentDetails()">
                <v-icon left>mdi-magnify</v-icon>Search
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              elevation="1"
              @click="alertValidation()"
              class="ms-2 mt-5"
              color="success"
            >
              Generate Indent
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              :class="{ 'ml-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              @input="searchData"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:450px;"
            />
          </v-col>
        </v-row>
        <!--Filter section end -->
      </v-card-text>
      <v-divider class="my-0" />
      <v-data-table
        :items-per-page="10"
        item-key="id"
        :headers="headers"
        :items="studentList"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.checkbox="{ item }">
          <v-checkbox
            color="accent"
            @change="selectStudentHandler(item)"
            v-model="item.isSelected"
            :disabled="!item.isStatus"
          ></v-checkbox>
        </template>
        <template v-slot:item.orderStatus="{ item }">
          <strong
            :class="
              item.orderStatus === 'PENDING'
                ? 'has-text-warning'
                : 'has-text-danger'
            "
            >{{ item.orderStatus }}</strong
          >
        </template>
        <template
          v-for="(type, k) in allTypes"
          v-slot:[`item.${type}`]="{ item }"
        >
          <div :key="k">
            <v-checkbox
              v-if="item[type] && item[type].length"
              :disabled="!item.isSelected || item[type].isTypeSelected"
              v-bind:key="type"
              color="accent"
              @change="selectTypeHandler(item, type)"
              v-model="item[type].isTypeSelected"
            ></v-checkbox>
            <table align="right">
              <tr v-for="(ele, i) in item[type]" v-bind:key="i">
                <td>
                  <span class="ms-1 me-1">{{ ele.subType || '-' }}</span>
                </td>
                <td>
                  <span class="ms-1 me-1">{{ ele.size || '-' }}</span>
                </td>
              </tr>
            </table>
            <span v-if="!item[type] || !item[type].length === 0">-</span>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="item.orderStatus === 'PENDING'"
            @click="
              selectAllModal = true
              editAllSize(item, item.index)
            "
            :disabled="!item.isSelected"
            color="success"
            class="px-2 ml-1 ma-1"
            min-width="0"
            small
          >
            <v-icon small> mdi-pencil </v-icon>
            <span class="ml-1">Select Size</span>
          </v-btn>

          <v-btn
            v-else-if="item.orderStatus === 'ORDER PLACED' && reorderUniform"
            @click="
              selectAllModal = true
              editAllSize(item, item.index)
            "
            :disabled="!item.isSelected"
            color="success"
            class="px-2 ml-1 ma-1"
            min-width="0"
            small
          >
            <v-icon small> mdi-pencil </v-icon>
            <span class="ml-1">Select Size</span>
          </v-btn>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center"
            >No Data Available</v-card-subtitle
          >
        </template>
      </v-data-table>
      <!--Pagination start-->
      <v-row>
        <v-col cols="4" sm="3">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per Page"
            @change="handlePageSizeChange"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="9">
          <v-pagination
            v-model="page"
            :length="totalPages"
            :total-visible="totalPages"
            @input="handlePageChange"
          >
          </v-pagination>
        </v-col>
      </v-row>
    </material-card>
    <!-- Loader Start -->
    <loading-icon :value="isLoading" />
    <!-- Loader End -->
    <!--Select All Size Modal -->
    <v-dialog
      persistent
      v-model="selectAllModal"
      :active="selectAllModal"
      :on-cancel="
        () => {
          selectAllModal = false
        }
      "
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <form>
        <v-card class="height-auto">
          <v-toolbar dark color="deep-purple lighten-1">
            <v-toolbar-title> Select Student Uniform Size</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="closeSelectSizeModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row key="1" v-if="editData.student.id">
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">
                      Student Name
                    </div>
                    <div class="text-button mb-1">
                      {{ editData.student.studentEnrollment.studentName }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">Gender</div>
                    <div class="text-button mb-1">
                      {{ editData.student.studentEnrollment.gender }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">Class</div>
                    <div class="text-button mb-1">
                      {{ editData.student.class }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">Section</div>
                    <div class="text-button mb-1">
                      {{ editData.student.section }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">
                      Franchisee Name
                    </div>
                    <div class="text-button mb-1">
                      {{ editData.student.franchisee.companyName }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">
                      Academic Year
                    </div>
                    <div class="text-button mb-1">
                      {{ editData.student.franchiseeAcademicYear.academicYear }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div class="holder">
              <v-tabs
                v-model="selectUniformSizeTab"
                background-color="deep-purple lighten-1"
                center-active
                dark
              >
                <v-tabs-slider color="Blue"></v-tabs-slider>
                <v-tab v-for="key in Object.keys(uniforms)" v-bind:key="key">
                  {{ key }}
                </v-tab>
                <v-tab-item
                  v-for="key in Object.keys(uniforms)"
                  v-bind:key="key"
                >
                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <v-tabs>
                        <v-tabs-slider
                          color="deep-purple lighten-1"
                        ></v-tabs-slider>
                        <v-tab
                          v-for="subType in Object.keys(uniforms[key])"
                          v-bind:key="subType"
                        >
                          {{ uniforms[key][subType].subType }}
                        </v-tab>
                        <v-tab-item
                          v-for="subType in Object.keys(uniforms[key])"
                          v-bind:key="subType"
                        >
                          <v-row>
                            <v-col cols="8" md="8" sm="8">
                              <div class="d-flex justify-space-between caption">
                                <div>
                                  <div class="black--text text-subtitle-2 mb-1">
                                    size
                                  </div>
                                  <div class="text-button mb-1">
                                    <v-autocomplete
                                      class="my-0 py-1"
                                      placeholder="Select Size"
                                      name="classSelect"
                                      required
                                      :items="
                                        uniforms[key][subType].productApparels
                                      "
                                      return-object
                                      key="id"
                                      v-model="
                                        uniforms[key][subType]
                                          .selectedProductDetails
                                      "
                                      item-text="size"
                                      :clearable="isClearable(key)"
                                    >
                                    </v-autocomplete>
                                  </div>
                                </div>
                                <template
                                  v-if="
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                  "
                                >
                                  <div
                                    class="col-md-2"
                                    v-if="
                                      uniforms[key][subType]
                                        .selectedProductDetails.chest
                                    "
                                  >
                                    <div
                                      class="black--text text-subtitle-2 mb-1"
                                    >
                                      Chest
                                    </div>
                                    <div class="black--text button mb-1">
                                      {{
                                        uniforms[key][subType]
                                          .selectedProductDetails
                                          ? uniforms[key][subType]
                                              .selectedProductDetails.chest ||
                                            '-'
                                          : '-'
                                      }}
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-2"
                                    v-if="
                                      uniforms[key][subType]
                                        .selectedProductDetails.frontLength
                                    "
                                  >
                                    <div
                                      class="black--text text-subtitle-2 mb-1"
                                    >
                                      Front Length
                                    </div>
                                    <div class="black--text button mb-1">
                                      {{
                                        uniforms[key][subType]
                                          .selectedProductDetails
                                          ? uniforms[key][subType]
                                              .selectedProductDetails
                                              .frontLength || '-'
                                          : '-'
                                      }}
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-2"
                                    v-if="
                                      uniforms[key][subType]
                                        .selectedProductDetails.shoulderSize
                                    "
                                  >
                                    <div
                                      class="black--text text-subtitle-2 mb-1"
                                    >
                                      Shoulder Size
                                    </div>
                                    <div class="black--text button mb-1">
                                      {{
                                        uniforms[key][subType]
                                          .selectedProductDetails
                                          ? uniforms[key][subType]
                                              .selectedProductDetails
                                              .shoulderSize || '-'
                                          : '-'
                                      }}
                                    </div>
                                  </div>
                                  <div
                                    class="col-md-2"
                                    v-if="
                                      uniforms[key][subType]
                                        .selectedProductDetails.waistRelax
                                    "
                                  >
                                    <div
                                      class="black--text text-subtitle-2 mb-1"
                                    >
                                      Waist Relax
                                    </div>
                                    <div class="black--text button mb-1">
                                      {{
                                        uniforms[key][subType]
                                          .selectedProductDetails
                                          ? uniforms[key][subType]
                                              .selectedProductDetails
                                              .waistRelax || '-'
                                          : '-'
                                      }}
                                    </div>
                                  </div>
                                  <div
                                    class="col-md-2"
                                    v-if="
                                      uniforms[key][subType]
                                        .selectedProductDetails.waistStretch
                                    "
                                  >
                                    <div
                                      class="black--text text-subtitle-2 mb-1"
                                    >
                                      Waist Stretch
                                    </div>
                                    <div class="black--text button mb-1">
                                      {{
                                        uniforms[key][subType]
                                          .selectedProductDetails
                                          ? uniforms[key][subType]
                                              .selectedProductDetails
                                              .waistStretch || '-'
                                          : '-'
                                      }}
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </v-col>
                            <v-col cols="4" md="4" sm="4">
                              <div>
                                <img
                                  v-if="
                                    uniforms[key][subType]
                                      .selectedProductDetails
                                  "
                                  class="img-fluid"
                                  width="500"
                                  height="600"
                                  :src="`${uniforms[key][subType].selectedProductDetails.sizeUrl}`"
                                  alt="not found"
                                />
                              </div>
                            </v-col>
                          </v-row>
                        </v-tab-item>
                      </v-tabs>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs>
              <v-btn
                @click="saveSelectedProducts()"
                color="success"
                class="align-button px-3 ml-1 ma-1 mt-5"
                min-width="0"
                absolute
                right
              >
                <v-icon small> mdi-pencil </v-icon>
                <span class="ml-1 text-strong">Save</span>
              </v-btn>
            </div>

            <hr />
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <!-- End-->

    <!--Review Modal Start-->
    <v-dialog
      persistent
      v-model="reviewModal"
      :active="reviewModal"
      :on-cancel="
        () => {
          reviewModal = false
        }
      "
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <form @submit.prevent="Save">
        <v-card class="height-auto">
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Indent Summary</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="closeReviewModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row key="1">
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">
                      Franchisee:
                    </div>
                    <div class="text-button mb-1">
                      {{ franchisee.companyName }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">
                      Student Count [Male]:
                    </div>
                    <div class="text-button mb-1">
                      {{ maleCount }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">
                      Student Count [Female]:
                    </div>
                    <div class="text-button mb-1">
                      {{ femaleCount }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="d-flex justify-space-between caption">
                  <div>
                    <div class="grey--text text-subtitle-2 mb-1">
                      Total Student Count:
                    </div>
                    <div class="text-button mb-1">
                      {{ maleCount + femaleCount }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <v-card
                  rounded="lg"
                  elevation="4"
                  width="300"
                  color="green"
                  dark
                >
                  <v-card-title
                    ><v-icon class="mr-3" size="50" color="white" left
                      >mdi-wallet</v-icon
                    >Wallet Balance</v-card-title
                  >
                  <v-card-subtitle class="pl-6"
                    ><span class="body-2 white--text font-weight-medium"
                      >(Wallet Balance:</span
                    ><span class="white--text mdi mdi-currency-inr body-1"
                      >{{ walletBalance }})</span
                    ></v-card-subtitle
                  >
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-0" />
            <v-row>
              <v-col
                v-for="key in Object.keys(finalSummary)"
                :key="key"
                cols="12"
                md="2"
              >
                <strong>{{ key }} </strong>
                <v-data-table
                  :items-per-page="10"
                  item-key="id"
                  :headers="summaryHeaders"
                  :items="finalSummary[key]"
                  disable-pagination
                  hide-default-footer
                >
                  <!-- <template v-slot:item.checkbox="{ item }"> </template> -->
                </v-data-table>
              </v-col>
            </v-row>
            <v-col id="errorReasons" v-if="errorReasons.length > 0">
              <div class="columns is-mobile">
                <div
                  class="column"
                  style="display: inline-block; margin-right: 5%"
                >
                  <b-button class="has-text-left" outlined type="is-success"
                    >Total: {{ count.success + count.failure }} </b-button
                  >&nbsp;
                  <b-button
                    class="button has-text-centered"
                    outlined
                    type="is-info"
                    >Success: {{ count.success }}</b-button
                  >&nbsp;
                  <b-button
                    class="button has-text-right"
                    outlined
                    type="is-danger"
                    >Failure: {{ count.failure }}</b-button
                  >
                </div>
              </div>
              <v-data-table
                :items-per-page="10"
                item-key="enrollmentCode"
                :headers="errorReasonsHeaders"
                :items="errorReasons"
              >
              </v-data-table>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeReviewModal()" class="mt-5">Cancel</v-btn>
            <v-btn
              :disabled="isDisable"
              elevation="1"
              @click="placeOrder()"
              class="ms-2 mt-5"
              color="success"
            >
              Assign Order
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import MaterialCard from '@/components/template/MaterialCard'
import _ from 'lodash'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
export default {
  name: 'uniformIndent',
  components: { MaterialCard, Multiselect },
  async created () {
    this.isSuperAdmin = Utils.helper.isSuperAdmin()
    this.reorderUniform = this.checkModuleAccess('reorderUniform')
    // await this.getStudentUniformSizes()
    await this.onStart()
  },
  mounted () {},
  data: function () {
    return {
      reorderUniform: false,
      isSuperAdmin: false,
      headers: [
        { text: 'Select', sortable: true, value: 'checkbox', width: '5%' },
        {
          text: 'Enrollment Code',
          sortable: true,
          value: 'studentEnrollment.enrollmentCode',
          width: '8%'
        },
        {
          text: 'Student Name',
          sortable: true,
          value: 'studentEnrollment.studentName',
          width: '8%'
        },
        {
          text: 'Gender',
          sortable: false,
          value: 'studentEnrollment.gender',
          width: '5%'
        },
        {
          text: 'Class & Section',
          sortable: false,
          value: 'classSection',
          width: '8%'
        }
        // { text: 'Class', sortable: false, value: 'studentEnrollment.studentAdmissions[0].class' },
        // { text: 'Section', sortable: true, value: 'studentEnrollment.studentAdmissions[0].section' }
      ],
      errorReasonsHeaders: [
        { text: 'Enrollment Code', sortable: true, value: 'enrollmentCode' },
        { text: 'Reason', sortable: true, value: 'message' }
      ],
      allSizeHeaders: [
        { text: 'Product Name', sortable: true, value: 'type' },
        { text: 'Size', sortable: true, value: 'sizes' },
        { text: 'Chest', sortable: true, value: 'chest' },
        { text: 'Front Length', sortable: true, value: 'frontLength' },
        { text: 'Shoulder Size', sortable: true, value: 'shoulderSize' },
        { text: 'Waist Relax', sortable: true, value: 'waistRelax' },
        { text: 'Waist Stretch', sortable: true, value: 'waistStretch' },
        { text: 'Image', sortable: true, value: 'sizeURL' }
      ],
      summaryHeaders: [
        { text: 'Size', sortable: true, value: 'size' },
        { text: 'Quantity', sortable: true, value: 'quantity' }
      ],
      classSectionArray: [],
      tab: 0,
      walletBalance: 0,
      classes: [],
      sections: [],
      selectedClassID: '',
      selectedClassSectionArray: [],
      studentList: [],
      selectedStudentList: [],
      allTypes: null,
      modalOk: false,
      reviewModal: false,
      finalSummary: [],
      selectAllModal: false,
      editSizeOptions: [],
      maleCount: 0,
      selectUniformSizeTab: null,
      SelectSizeTab: null,
      image_Url: null,
      femaleCount: 0,
      editData: {
        product: {},
        student: {},
        size: '',
        index: ''
      },
      uniforms: {},
      uniformData: {
        data: {
          REGULAR: [],
          SPORT: [],
          WINTER: []
        },
        maleUniformsData: [],
        femaleUniformsData: [],
        summary: [],
        summayHeaders: [
          {
            text: 'Qty',
            value: 'qty'
          },
          {
            text: 'Size',
            value: 'size'
          }
        ],
        male: {
          REGULAR: [],
          SPORT: [],
          WINTER: [],
          all: []
        },
        female: {
          REGULAR: [],
          SPORT: [],
          WINTER: [],
          all: []
        }
      },
      count: {
        success: 0,
        failure: 0
      },
      filter: {
        classId: '',
        sectionId: '',
        franchiseeId: '',
        academicYearID: ''
      },
      franchiseeID: '',
      academicYearID: '',
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 40, 100],
      totalPages: 0,
      isLoading: false,
      tabImages: {},
      apparelTypes: [],
      selectedOrderStatus: 0,
      errorReasons: [],
      orderStatusOptions: [
        {
          id: 0,
          name: 'All'
        },
        {
          id: 1,
          name: 'ORDER PLACED'
        },
        {
          id: -1,
          name: 'PENDING'
        },
        {
          id: -2,
          name: 'PAYMENT PENDING'
        }
      ],
      isDisable: false,
      selectedTypProducts: [],
      search: null,
      isWinterJacketCompulsory: true
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      // Reset the class dropdown selected options on franchisee change
      this.selectedClassSectionArray = []
      await this.onStart()
    },
    academicYear: async function (val) {
      await this.onStart()
    }
  },
  methods: {
    isClearable (type) {
      let isClear = false
      if (type === 'WINTER' && !this.isWinterJacketCompulsory) {
        isClear = true
      }
      return isClear
    },
    searchData () {
      if (this.search?.trim()) {
        this.page = 1
        this.getStudentDetails()
      } else {
        this.getStudentDetails()
      }
    },
    onStart: async function () {
      try {
        console.log('this.reorderUniform ', this.reorderUniform)
        this.isDisable = false
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
            // this.isWinterJacketCompulsory = this.franchisee.winterJacketCompulsory || true
            this.walletBalanceFunc()
          } else {
            this.franchiseeID = ''
            // this.isWinterJacketCompulsory = true
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          if (this.franchiseeID && this.academicYearID) {
            this.getClassList()
            this.getStudentDetails()
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    alertValidation: function () {
      this.selectedStudentList = this.studentList.filter(
        (obj) => obj.isSelected
      )
      if (
        _.map(this.selectedStudentList, 'orderStatus').indexOf('ORDER PLACED') >
        -1
      ) {
        this.$dialog.confirm({
          title: 'Alert',
          text: 'Order already placed for selected students, do you want to continue ?',
          actions: {
            false: {
              text: 'No'
            },
            true: {
              color: 'success',
              text: 'Yes',
              handle: async () => {
                this.generateIndentPreview()
              }
            }
          }
        })
      } else {
        this.generateIndentPreview()
      }
    },
    generateIndentPreview: function () {
      this.isDisable = false
      this.selectedStudentList = this.studentList.filter(
        (obj) => obj.isSelected
      )

      if (!this.selectedStudentList.length) {
        return this.errMsg('Please Select Students')
      }
      let maleStudents = this.selectedStudentList.filter(
        (obj) => obj.studentEnrollment.gender === constants.GENDER.male
      )
      this.maleCount = maleStudents.length
      let femaleStudents = this.selectedStudentList.filter(
        (obj) => obj.studentEnrollment.gender === constants.GENDER.female
      )
      this.femaleCount = femaleStudents.length
      let errorArray = []
      if (this.selectedStudentList.length !== this.selectedTypProducts.length) {
        return this.$buefy.toast.open({
          message: `Please select checkbox of uniform type to place order`,
          type: 'is-danger',
          duration: 10000
        })
      }
      for (let student of this.selectedStudentList) {
        let isSelectedIndex = this.selectedTypProducts
          .map((item) => item.studentID)
          .indexOf(student.id)
        let typeArray = this.selectedTypProducts[isSelectedIndex].types
        if (typeArray.length === 0) {
          return this.$buefy.toast.open({
            message: `Please select uniform selected students.`,
            type: 'is-danger',
            duration: 5000
          })
        }
        let availableProductType = []
        _.map(student.studentUniformMaps, function (obj) {
          for (let type of typeArray) {
            if (obj.productApparelType.type === type) {
              availableProductType.push(obj)
            }
          }
        })
        student.studentUniformMaps = _.intersectionBy(
          student.studentUniformMaps,
          availableProductType,
          'id'
        )
        console.log(
          'student.studentUniformMaps ',
          student.studentUniformMaps.length
        )
        if (student.studentUniformMaps.length === 0) {
          return this.$buefy.toast.open({
            message: `Please select uniform size selected students.`,
            type: 'is-danger',
            duration: 5000
          })
        }
      }
      // ${errorArray.join('\n')}`
      if (errorArray.length) {
        return this.$buefy.toast.open({
          message: `Please select all uniform sizes for ${errorArray.length} ${
            errorArray.length === 1 ? 'student' : 'students'
          } in the selected students.`,
          type: 'is-danger',
          duration: 5000
        })
      }
      let selectedProducts = this.selectedStudentList.map(
        (obj) => obj.studentUniformMaps
      )

      const productsSummary = []
      selectedProducts = selectedProducts.flat()
      for (let type of this.apparelTypes) {
        let products = selectedProducts.filter(
          (obj) => obj.productApparelType.id === type.id
        )
        products = _.groupBy(products, 'size')
        let sizeArray = []
        for (let product of Object.keys(products)) {
          if (products[product].length) {
            sizeArray.push({
              size: product,
              quantity: products[product].length
            })
          }
        }
        if (sizeArray.length) {
          productsSummary[`${type.type}-${type.subType}`] = sizeArray
        }
      }

      this.finalSummary = productsSummary

      this.reviewModal = true
    },
    walletBalanceFunc: async function () {
      try {
        if (this.franchisee.id) {
          this.walletBalance = 0
          this.isLoading = true
          const data = await http.get(
            `${constants.API_URL}/api/franchisee/wallet/${this.franchisee.id}`
          )
          this.isLoading = false
          this.walletBalance = data.data.openingAmount.toFixed(2)
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)

        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    closeSelectSizeModal: function () {
      this.uniforms = []
      this.selectAllModal = false
    },
    placeOrder: async function () {
      try {
        if (!this.selectedStudentList.length) {
          return this.errMsg('Please select students to place order')
        }
        let restrictVirtualOrder = this.selectedStudentList.filter(obj => obj.assignVirtualOrder == null)
        if (restrictVirtualOrder.length > 0) {
          return this.errMsg('Virtual curriculum kit 2 order is not available. Please place curriculum kit 1 order.')
        }

        this.$dialog.confirm({
          title: 'Place Order',
          text: 'Are you sure you want to place this order?',
          actions: {
            false: {
              text: 'No'
            },
            true: {
              color: 'success',
              text: 'Yes',
              handle: async () => {
                try {
                  let studentsArray = this.selectedStudentList.map((obj) => {
                    return {
                      enquiryID: obj.studentEnrollment.enquiryID,
                      assignVirtualOrderID: obj.assignVirtualOrder.id,
                      enrollmentCode: obj.studentEnrollment.enrollmentCode,
                      admissionID: obj.id,
                      products: obj.studentUniformMaps.map((std) => {
                        return {
                          productID: std.productID,
                          quantity: std.quantity,
                          size: std.size,
                          apparelTypeID: std.apparelTypeID
                        }
                      })
                    }
                  })
                  const { data } = await http.post(
                    `${constants.API_URL}/api/assign-student-kit2`,
                    {
                      data: studentsArray
                    }
                  )
                  this.errorReasons = data.failedReasons
                  this.count.success = data.success
                  this.count.failure = data.failure
                  this.isDisable = data.failure > 0
                  console.log('this.isDisable ', this.isDisable)
                  if (this.count.failure === 0) {
                    this.isDisable = false
                    // All Indents are successfully placed
                    this.closeReviewModal()
                  }
                  let message = `Total Indent's: ${
                    data.success + data.failure
                  } <br/>`
                  if (data.failure) {
                    message = message + `Failed Indent: ${data.failure} `
                  }
                  if (data.success) {
                    message = message + `  Succeed Indent: ${data.success}<br/><b>Order placed successfully for CURRICULUM KIT 2</b>`
                  }
                  this.$dialog.info({
                    text: message,
                    title: 'Uniform Indent'
                  })
                } catch (e) {
                  this.isLoading = false
                  const errorMessage =
                    (e && e.response && e.response.data.message) || e.message
                  return this.$dialog.error({
                    text: errorMessage,
                    title: 'Error'
                  })
                }
              }
            }
          }
        })
      } catch (e) {
        console.log(e)
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    saveSelectedProducts: async function () {
      try {
        let studentAppreals = []
        this.selectedTypProducts = []
        let indentStudent = this.editData.student
        let selectedProducts = []
        for (let key in this.uniforms) {
          for (let obj of this.uniforms[key]) {
            if (obj.selectedProductDetails) {
              selectedProducts.push(obj.selectedProductDetails)
            }
          }
        }
        studentAppreals = []
        let requiredSizes
        if (!this.isWinterJacketCompulsory) {
          // winter products are optional
          requiredSizes = this.apparelTypes
            .filter(
              (obj) =>
                obj.type !== 'WINTER' &&
              (_.isEqual(obj.gender, indentStudent.studentEnrollment.gender) ||
              _.isEqual(obj.gender, constants.GENDER.both))
            )
            .map((obj) => obj.id)
        } else {
          // all compulsory
          requiredSizes = this.apparelTypes
            .filter(
              (obj) =>
                _.isEqual(obj.gender, indentStudent.studentEnrollment.gender) ||
              _.isEqual(obj.gender, constants.GENDER.both)
            )
            .map((obj) => obj.id)
        }

        const selectedProductSizes = selectedProducts.map(
          (obj) => obj.productTypeID
        )
        if (selectedProductSizes.length < requiredSizes.length) {
          return this.$buefy.toast.open({
            message: 'Please select all required uniform sizes',
            type: 'is-danger',
            duration: 5000
          })
        }
        studentAppreals = selectedProducts.map((prod) => {
          return {
            enquiryID: indentStudent.studentEnrollment.enquiryID,
            studentAdmissionID: indentStudent.id,
            classID: indentStudent.classID,
            productID: prod.productID,
            apparelTypeID: prod.productTypeID,
            size: prod.size,
            quantity: prod.quantity
          }
        })
        await http.post(`${constants.API_URL}/api/product/student-appreal`, {
          enquiryID: indentStudent.studentEnrollment.enquiryID,
          franchiseeID: indentStudent.franchisee.id,
          academicYearID: indentStudent.academicYearID,
          classID: indentStudent.classID,
          studentAppreals: studentAppreals,
          gender: _.upperCase(indentStudent.studentEnrollment.gender)
        })
        this.uniforms = []
        this.selectAllModal = false
        await this.getStudentDetails()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('saveSelectedProducts', errorMessage)
        this.errMsg(errorMessage)
      }
    },
    editAllSize: function (student, index) {
      this.editData.student = student
      this.editData.index = index
      this.getStudentUniforms(
        student,
        student.class,
        student.studentEnrollment.gender
      )
    },
    validateVirtualOrder: function () {
      return this.$buefy.dialog.alert({
        message: 'Virtual curriculum kit2 order is not available. Please place curriculum kit1 order.',
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    closeReviewModal: function () {
      this.selectedStudentList = []
      this.errorReasons = []
      this.count.success = 0
      this.count.failure = 0
      this.reviewModal = false
      this.getStudentDetails()
      this.selectedTypProducts = []
    },
    getStudentDetails: async function (isFromFilter = false) {
      try {
        let payload = {}
        this.studentList = []
        if (isFromFilter) {
          this.page = 1
        }
        payload.franchiseeID = this.franchisee.id
        payload.academicYearID = this.academicYear.id
        payload.isOrderRequired = this.selectedOrderStatus
        let classIds = this.selectedClassSectionArray.map((item) => {
          return item.classID
        })
        if (classIds.length > 0) {
          payload.classID = _.uniqBy(classIds)
        }
        let sectionIds = this.selectedClassSectionArray.map((item) => {
          return item.id.sectionID
        })
        if (sectionIds.length > 0) {
          payload.sectionID = sectionIds
        }

        if (this.search) payload.search = this.search

        let { data } = await http.post(
          `${constants.API_URL}/api/product/student-appreal/details`,
          Object.assign(
            {
              page: this.page - 1,
              size: this.pageSize
            },
            payload
          )
        )
        let apparelTypes = await http.get(
          `${constants.API_URL}/api/product/apparel-types`
        )
        this.apparelTypes = apparelTypes.data
        let apparelTypesGroup = await _.groupBy(apparelTypes.data, 'type')
        let allKeys = Object.keys(apparelTypesGroup)
        this.allTypes = allKeys
        for (let type of allKeys) {
          if (!this.headers.find((obj) => obj.text === type)) {
            this.headers.push({ text: type, sortable: true, value: type })
          }
        }
        if (!this.headers.find((obj) => obj.text === 'Order Status')) {
          this.headers.push({
            text: 'Order Status',
            sortable: true,
            value: 'orderStatus',
            width: '8%'
          })
        }
        if (!this.headers.find((obj) => obj.text === 'Order Id')) {
          this.headers.push({
            text: 'Order Id',
            sortable: true,
            value: 'latestOrderId',
            width: '5%'
          })
        }
        if (!this.headers.find((obj) => obj.text === 'Actions')) {
          this.headers.push({
            text: 'Actions',
            sortable: true,
            value: 'action',
            width: '5%'
          })
        }

        for (let student of data.rows) {
          student.latestOrderId = '-'
          if (_.isArray(student.orders)) {
            let orders = student.orders
            if (student.orders.length > 0) {
              student.orderStatus = 'ORDER PLACED'
              // Latest order id in the 0th index after sort operation
              orders = _.orderBy(
                orders,
                function (o) {
                  return moment(o.createdAt).format('YYYYMMDD')
                },
                ['desc']
              )
              student.latestOrderId = orders[0].orderID
            } else if (student.assignOrders.length > 0) {
              student.latestOrderId = student.assignOrders[0].orderID
              student.orderStatus = 'PENDING'
            } else {
              student.orderStatus = 'PENDING'
            }
          } else {
            student.orderStatus = 'PENDING'
          }
          // student.class = student.class
          // student.section = student.section
          student.classSection = `${student.class}-${student.section}`

          if (_.map(this.selectedStudentList, 'id').indexOf(student.id) > -1) {
            // Previous selection in the client side exist
            student.isSelected = true
          } else {
            student.isSelected = false
          }

          if (student.studentUniformMaps.length) {
            for (let uniform of student.studentUniformMaps) {
              const uniformTypeID = uniform.apparelTypeID
              const apparelType = apparelTypes.data.find(
                (obj) => obj.id === uniformTypeID
              )
              if (!student[apparelType.type]) {
                student[apparelType.type] = []
                if (student[apparelType.type]) student[apparelType.type].isTypeSelected = false
              } else {
                // student[apparelType.type] = []
                if (student[apparelType.type]) student[apparelType.type].isTypeSelected = false
              }
              student[apparelType.type].push({
                subType: uniform.productApparelType.subType,
                size: uniform.size || '-'
              })
            }
          } else {
            for (let type of allKeys) {
              student[type] = '-'
              // student[type].isTypeSelected = true
            }
          }
          if (student.isSelected) {
            this.selectStudentHandler(student)
          }
        }
        this.uniforms = []
        this.studentList = data.rows
        this.studentList.forEach((item) => {
          if (item.orderStatus === 'PENDING') {
            item.isStatus = true
          } else if (this.isSuperAdmin) {
            item.isStatus = true
          } else {
            item.isStatus = false
          }
        })

        this.isWinterJacketCompulsory = this.studentList.length ? this.studentList[0].franchisee.winterJacketCompulsory : true
        this.totalPages = data.totalPages
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log(errorMessage)
        this.errMsg(errorMessage)
      }
    },
    getStudentUniforms: async function (student, classId, gender) {
      try {
        let uniforms = await http.get(
          `${constants.API_URL}/api/product/size-by-user`,
          {
            params: {
              enquiryID: student.studentEnrollment.enquiryID,
              academicYearID: student.academicYearID,
              gender: gender
            }
          }
        )

        this.uniforms = uniforms.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.messagec
        this.errMsg(errorMessage)
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        this.classSectionArray = []
        let z = []

        let { data } = await http.get(
          `${constants.API_URL}/api/student/get-all-classby-franchisee`,
          {
            params: {
              franchiseeID: this.franchisee?.id || '',
              academicYearID: this.academicYear?.id || ''
            }
          }
        )
        if (data) {
          _.map(data, (a) => {
            _.map(a.studentSections, (b) => {
              let franchiseeName =
                b.studentAdmissions[0]?.franchisee?.companyName || '-'
              let franchiseeId = b.studentAdmissions[0]?.franchisee?.id || '-'
              b.value = `${franchiseeName}-${a.name} - ${b.name}`
              b.id = { franchiseeID: franchiseeId, sectionID: b.id }
              z.push(b)
            })
          })
        }

        this.classSectionArray = z
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        // this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    selectStudentHandler: function (student) {
      // Searching in the selected student list
      let isSelectedIndex = this.selectedStudentList
        .map((item) => item.id)
        .indexOf(student.id)
      let isTypeSelectedIndex = this.selectedTypProducts
        .map((item) => item.studentID)
        .indexOf(student.id)
      if (isSelectedIndex > -1) {
        // This student is already selected
        if (!student.isSelected) {
          // Deselecting the student as checkbox is unchecked
          this.selectedStudentList.splice(isSelectedIndex, 1)
          if (isTypeSelectedIndex > -1) {
            this.selectedTypProducts.splice(isTypeSelectedIndex, 1)
          }
        }
      } else {
        this.selectedStudentList.push(student)
      }
      this.allTypes.forEach(type => {
        if (student.isSelected) {
          if (!this.isWinterJacketCompulsory && type === 'WINTER') {
            if (student[type]) student[type].isTypeSelected = false
          } else {
            if (student[type]) student[type].isTypeSelected = true
            this.selectTypeHandler(student, type)
          }
        } else {
          if (student[type]) student[type].isTypeSelected = false
        }
      })
    },
    handlePageChange: function (value) {
      this.page = value
      this.getStudentDetails()
    },
    handlePageSizeChange: function (size) {
      this.pageSize = size
      this.page = 1
      this.getStudentDetails()
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    selectTypeHandler: function (student, type) {
      let isSelectedIndex = this.selectedTypProducts
        .map((item) => item.studentID)
        .indexOf(student.id)
      if (isSelectedIndex > -1) {
        if (
          !this.selectedTypProducts[isSelectedIndex].types &&
          !this.selectedProducts[isSelectedIndex].types.length
        ) {
          this.selectedTypProducts[isSelectedIndex].types.push(type)
        } else {
          let element = this.selectedTypProducts[isSelectedIndex]
          let isTypeSelectedIndex = element.types
            .map((item) => item)
            .indexOf(type)

          if (isTypeSelectedIndex > -1) {
            this.selectedTypProducts[isSelectedIndex].types.splice(
              isTypeSelectedIndex,
              1
            )
            if (this.selectedTypProducts[isSelectedIndex].types.length === 0) {
              this.selectedTypProducts.splice(isSelectedIndex, 1)
            }
          } else {
            this.selectedTypProducts[isSelectedIndex].types.push(type)
          }
        }
      } else {
        let obj = {}
        obj.studentID = student.id
        obj.types = []
        obj.types.push(type)
        this.selectedTypProducts.push(obj)
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
<style scoped>
.height-auto {
  height: 100vh;
  overflow-y: scroll;
}
.holder {
  position: relative;
}
.orderGapClass {
  position: absolute;
  right: 142px;
  top: 58px;
  z-index: 1;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
